import { brandingRequest } from '@frontend/account/events';
import { Branding } from '@frontend/account/types';
import { EntityType } from '@frontend/common';
import { ObjectBadge, ObjectBadgeProps } from '@frontend/rendering/badge';
import React from 'react';

export const BrandingBadge = (props: ObjectBadgeProps<Branding>) => {
    return (
        <ObjectBadge<Branding>
            id={props.id}
            type={EntityType.BRANDING}
            mapDisplayName={(branding: Branding) => branding.domain}
            resolve={brandingRequest}
            navigateString={(object: Branding) => `/brandings/${object.id}`}
            {...props}
        />
    );
};